export default {
	get: function(){
		return {
	 		history: []
		}
	}
}
